import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { KiAnbieter, MeinProjekt } from '@beholder/shared';
import { api } from '../api';
import { useIch } from '../sitzung';
import { Auswahl, Eingabe, Feld, Karte, Knopf, Meldung, Textfeld, useAktion } from '../ui';

const KI_NAMEN: Record<KiAnbieter, string> = {
  lokal: 'Lokale KI (auf dem eigenen Server), Claude als Ersatz',
  claude: 'Claude',
  aus: 'Keine KI',
};

export function ProjektEinstellungen({ projekt, neuLaden }: { projekt: MeinProjekt; neuLaden(): void }) {
  const ich = useIch();
  const nav = useNavigate();
  const [name, setName] = useState(projekt.name);
  const [beschreibung, setBeschreibung] = useState(projekt.beschreibung);
  const [ki, setKi] = useState<KiAnbieter>(projekt.kiAnbieter);
  const [ok, setOk] = useState('');
  const a = useAktion();
  const loeschen = useAktion();
  const [bestaetigung, setBestaetigung] = useState('');

  async function speichern() {
    setOk('');
    const r = await a.ausfuehren(() => api.patch(`/api/projekte/${projekt.id}`, { name, beschreibung, kiAnbieter: ki }));
    if (r) {
      setOk('Gespeichert');
      neuLaden();
    }
  }
  async function archivieren() {
    const r = await a.ausfuehren(() => api.patch(`/api/projekte/${projekt.id}`, { archiviert: !projekt.archiviert }));
    if (r) neuLaden();
  }
  async function endgueltigLoeschen() {
    const r = await loeschen.ausfuehren(() => api.delete(`/api/projekte/${projekt.id}`, { bestaetigung }));
    if (r) nav('/');
  }

  return (
    <div className="seite schmal">
      <Karte titel="Projekt">
        <div className="stapel">
          <Feld titel="Name">
            <Eingabe value={name} onChange={(e) => setName(e.target.value)} maxLength={120} />
          </Feld>
          <Feld titel="Beschreibung">
            <Textfeld rows={4} value={beschreibung} onChange={(e) => setBeschreibung(e.target.value)} />
          </Feld>
          <Feld titel="KI-Hilfe in diesem Projekt" hinweis="Bei „Claude“ gehen Projektinhalte zur Beantwortung an Anthropic.">
            <Auswahl value={ki} onChange={(e) => setKi(e.target.value as KiAnbieter)}>
              {(Object.keys(KI_NAMEN) as KiAnbieter[]).map((k) => (
                <option key={k} value={k}>
                  {KI_NAMEN[k]}
                </option>
              ))}
            </Auswahl>
          </Feld>
          <Meldung>{a.fehler}</Meldung>
          <Meldung art="ok">{ok}</Meldung>
          <div className="reihe">
            <Knopf art="haupt" onClick={speichern} disabled={a.laeuft || !name.trim()}>
              Speichern
            </Knopf>
          </div>
        </div>
      </Karte>
      <Karte titel={projekt.archiviert ? 'Archiviert' : 'Archivieren'}>
        <p className="leise">
          {projekt.archiviert
            ? 'Das Projekt ist archiviert und kann nur gelesen werden.'
            : 'Ein archiviertes Projekt bleibt vollständig erhalten, kann aber nicht mehr geändert werden.'}
        </p>
        <Knopf onClick={archivieren} disabled={a.laeuft}>
          {projekt.archiviert ? 'Wieder aktivieren' : 'Archivieren'}
        </Knopf>
      </Karte>
      {ich.istHauptadmin && (
        <Karte titel="Endgültig löschen" className="karte-gefahr">
          <p className="leise">Löscht das Projekt mit allen Inhalten und Dateien. Das kann nicht rückgängig gemacht werden.</p>
          <Feld titel={`Zur Bestätigung „${projekt.name}“ eingeben`}>
            <Eingabe value={bestaetigung} onChange={(e) => setBestaetigung(e.target.value)} />
          </Feld>
          <Meldung>{loeschen.fehler}</Meldung>
          <Knopf art="gefahr" disabled={bestaetigung !== projekt.name || loeschen.laeuft} onClick={endgueltigLoeschen}>
            Projekt endgültig löschen
          </Knopf>
        </Karte>
      )}
    </div>
  );
}
